import type { ReactNode } from 'react';
import './FaixaDeFiltros.css';

/**
 * Faixa de filtros dentro do conteúdo.
 *
 * A moldura da página já tem uma faixa própria, mas ela é única — e a tela de
 * Usuários tem duas listagens, cada uma com o seu recorte (UC13). Cada aba
 * traz a sua faixa junto, em vez de o cabeçalho mudar de conteúdo conforme a
 * aba: filtro que troca sozinho embaixo do cursor é filtro que ninguém confia.
 */
export function FaixaDeFiltros({
  rotulo,
  children,
}: {
  /** Nome do grupo para o leitor de tela ("Filtros de usuários do painel"). */
  readonly rotulo: string;
  readonly children: ReactNode;
}) {
  return (
    <div className="faixa-filtros" role="group" aria-label={rotulo}>
      {children}
    </div>
  );
}
